/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 10:19:12 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  DateInput,
  Filter,
  ReferenceInput,
  SelectInput,
  TextInput,
  useTranslate,
} from 'react-admin';
import { DateInput as ReactAdminDateInput } from 'react-admin-date-inputs';
import moment from 'moment';
import { inspectionStatusOptions, towerStatusOptions } from 'utils/choices';
import { filterStyle } from 'styles';

const InspectionFilters = ({ organisationFilter, ...props }) => {
  const translate = useTranslate();
  const classes = filterStyle();

  return (
    <Filter className={classes.root} {...props}>
      <TextInput source="towerId" label="resources.Inspection.fields.towerId" />
      <ReferenceInput
        label="resources.Inspection.fields.organisation"
        source="organisationId"
        reference="Organisation"
        emptyText={translate('resources.Inspection.noOrganisations')}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={organisationFilter}
        alwaysOn
      >
        <SelectInput
          source="id"
          optionText="name"
          options={{
            InputLabelProps: { shrink: true },
            SelectProps: { displayEmpty: true },
          }}
        />
      </ReferenceInput>
      <ReferenceInput
        label="resources.Inspection.fields.project"
        source="projectId"
        reference="Project"
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="resources.Inspection.fields.site"
        source="siteId"
        reference="Site"
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
      <SelectInput
        source="cmsStatus"
        label="resources.Inspection.fields.inspectionStatus"
        choices={inspectionStatusOptions}
      />
      <SelectInput
        source="towerCmsStatus"
        label="resources.Inspection.fields.towerStatus"
        choices={towerStatusOptions}
      />
      {window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Chrome') === -1 ? (
        <ReactAdminDateInput
          source="dateFrom"
          label="resources.Inspection.fields.dateFrom"
          alwaysOn
          noValidate
          parse={date =>
            moment
              .utc(date)
              .startOf('day')
              .toDate()
          }
          options={{
            format: 'dd/MM/yyyy',
            required: false,
            clearable: true,
          }}
        />
      ) : (
        <DateInput
          source="dateFrom"
          alwaysOn
          parse={date =>
            moment
              .utc(date)
              .startOf('day')
              .toDate()
          }
          label={'resources.Inspection.fields.dateFrom'}
        />
      )}
      {window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Chrome') === -1 ? (
        <ReactAdminDateInput
          source="dateTo"
          label="resources.Inspection.fields.dateTo"
          alwaysOn
          noValidate
          parse={date =>
            moment
              .utc(date)
              .endOf('day')
              .toDate()
          }
          format={
            date =>
              moment
                .utc(date)
                .endOf('day')
                .format('YYYY-MM-DD') //required format for input
          }
          options={{
            format: 'dd/MM/yyyy',
            required: false,
            clearable: true,
          }}
        />
      ) : (
        <DateInput
          source="dateTo"
          parse={date =>
            moment
              .utc(date)
              .endOf('day')
              .toDate()
          }
          format={
            date =>
              moment
                .utc(date)
                .endOf('day')
                .format('YYYY-MM-DD') //required format for input
          }
          alwaysOn
          label="resources.Inspection.fields.dateTo"
        />
      )}
    </Filter>
  );
};

export default InspectionFilters;
